import authRoute from "./authRoute";
import clientdRoute from "./clientdRoute";
import clientsAccountRoute from "./clientsAccountRoute";
import pagesRoute from "./pagesRoute";
export const publicRoutes = [...authRoute];

export const protectedRoutes = [
  ...clientdRoute,
  ...clientsAccountRoute,
  ...pagesRoute,
];
